import { apiRequest } from '../modules/shared/hook/useApi';
import {
  IBooking,
  IBookingEvent,
  IMentor,
  IMentorDetails,
  IUser,
  Recommendations,
} from '../types';

export const getBookings = async () => {
  const result = await apiRequest<Array<IBooking>>('getMyBookings');

  return result;
};

export const cancelBooking = async (params: Record<string, any>) => {
  const result = await apiRequest('cancelBooking', params);
  return result;
};

export const getMentors = async (): Promise<{
  mentors: IMentor[];
  mentorsDetails: IMentorDetails[];
}> => {
  const mentors = await apiRequest<IMentor[]>('getActiveMentors');
  const mentorsDetails = await apiRequest<IMentorDetails[]>('getMentorDetails');

  const result = { mentors, mentorsDetails };

  return result;
};

export const getOfferings = async (): Promise<IBookingEvent[]> => {
  const result = await apiRequest<IBookingEvent[]>('getUpcomingEvents');
  return result;
};

export const getRecommendations = async (): Promise<Recommendations> => {
  const result = await apiRequest<Recommendations>('getRecommendations');
  return result;
};

export const getUser = async (): Promise<IUser> => {
  const result = await apiRequest<IUser>('getAuthUser');
  return result;
};
